import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.replace
// 修改 原型对象中的push方法
VueRouter.prototype.replace = function replace(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = [{
	path: '/',
	name: 'Home',
	component: () => import( /* webpackChunkName: "about" */ '../views/Home.vue'),
	children: [{
		path: '/',
		name: 'index',
		component: () => import( /* webpackChunkName: "about" */ '../views/index.vue'),
	},{
		path: '/contact_us',
		meta:{
			name:'CONTACT US'
		},
		name: 'contact_us',
		component: () => import( /* webpackChunkName: "about" */ '../views/contact_us.vue'),
	},{
		path: '/about',
		meta:{
			name:'JINLERY AND PARTNERS'
		},
		name: 'about',
		component: () => import( /* webpackChunkName: "about" */ '../views/about.vue'),
	},{
		path: '/use',
		meta:{
			name:'Terms of use'
		},
		name: 'use',
		component: () => import( /* webpackChunkName: "about" */ '../views/use.vue'),
	},{
		path: '/xieyi',
		meta:{
			name:'Terms of use'
		},
		name: 'xieyi',
		component: () => import( /* webpackChunkName: "about" */ '../views/xieyi.vue'),
	},{
		path: '/check',
		meta:{
			name:'SECURITY TESTING'
		},
		name: 'check',
		component: () => import( /* webpackChunkName: "about" */ '../views/check.vue'),
	},{
		path: '/news',
		meta:{
			name:'JOURNALISM'
		},
		name: 'news',
		component: () => import( /* webpackChunkName: "about" */ '../views/news.vue'),
	},{
		path: '/news-info',
		meta:{
			name:'JINLERY AND PARTNERS'
		},
		name: 'newsinfo',
		component: () => import( /* webpackChunkName: "about" */ '../views/news-info.vue'),
	},{
		path: '/list',
		meta:{
			name:'WRIST WATCH'
		},
		name: 'list',
		component: () => import( /* webpackChunkName: "about" */ '../views/list.vue'),
	},{
		path: '/info',
		meta:{
			name:'info'
		},
		name: 'info',
		component: () => import( /* webpackChunkName: "about" */ '../views/info.vue'),
	},{
		path: '/asked',
		meta:{
			name:'asked'
		},
		name: 'asked',
		component: () => import( /* webpackChunkName: "about" */ '../views/asked.vue'),
	},{
		path: '/pictures',
		meta:{
			name:'pictures'
		},
		name: 'pictures',
		component: () => import( /* webpackChunkName: "about" */ '../views/pictures.vue'),
	},{
		path: '/videos',
		meta:{
			name:'videos'
		},
		name: 'videos',
		component: () => import( /* webpackChunkName: "about" */ '../views/videos.vue'),
	}]
}]

const router = new VueRouter({
	routes
})
router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0)
	next()
});

export default router
